import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { StorePodContext } from '../StorePod.context';
import { StorePodLoader } from './StorePodLoader';

const { bool, string } = proptypes;

export const StorePodAddress = ({ displaySingleLine = false, height = 'tight' }) => {
  const { loading, store } = useContext(StorePodContext);
  const {
    city,
    postalCode,
    state,
    street
  } = store?.address || {};

  if (loading) {
    return (
      <div data-testid="store-pod-address-loader" data-component="StorePodAddressLoader">
        <StorePodLoader height="2rem" />
        {!displaySingleLine && <StorePodLoader height="2rem" />}
      </div>
    );
  }

  return (
    <div data-component="StorePodAddress">
      {!displaySingleLine && (
        <>
          <div className="sui-overflow-hidden sui-text-ellipsis">
            <Typography height={height}>{street}</Typography>
          </div>
          <div className="sui-overflow-hidden sui-text-ellipsis">
            <Typography height={height}>{`${city}, ${state} ${postalCode}`}</Typography>
          </div>
        </>
      )}
      {displaySingleLine && (
        <div className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap">
          <Typography height={height}>{`${street}, ${city}, ${state} ${postalCode}`}</Typography>
        </div>
      )}
    </div>
  );
};

StorePodAddress.propTypes = {
  displaySingleLine: bool,
  height: string
};

StorePodAddress.displayName = 'StorePodAddress';
